import type { BorderColors } from '../../../../tokens/colors/types';
import { neutral } from './palette';
import { positive } from './semantic';

export const border: BorderColors = {
  focused: neutral[70],
  default: neutral[50],
  disabled: neutral[10],
  selected: positive[70],
};
